import { exec } from '../utils';
import type {
  AuthenticateFromOktaArgs,
  AuthenticateFromOktaResult,
  AuthenticateFromOktaExecResponse,
} from '@src/types';

const AUTHENTICATE_FROM_OKTA_MUTATION = `
  mutation authenticateFromOkta(
    $idToken: String!
    $accessToken: String!
    $nonce: String!
    $adminAuth: Boolean
  ) {
    authenticateFromOkta(
      idToken: $idToken
      accessToken: $accessToken
      nonce: $nonce
      adminAuth: $adminAuth
    ) {
      user {
        uuid
        name
        email
        oneTimeToken
      }
      idp {
        idpId
        idpName
      }
      token
    }
  }
`;

export const authenticateFromOkta = async (
  params: AuthenticateFromOktaArgs
): Promise<AuthenticateFromOktaResult> => {
  const data = await exec<AuthenticateFromOktaArgs, AuthenticateFromOktaExecResponse>(
    AUTHENTICATE_FROM_OKTA_MUTATION,
    { variables: params },
  );

  return data.authenticateFromOkta;
};
